module.exports = __webpack_public_path__ + "static/img/triple ring.f66f447.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logos/triple ring.jpg
// module id = UEf4
// module chunks = 1